import React from "react";
import { useGetTodoQuery } from "@graphql";
import { Spinner } from "@components";
import { TicketCard } from "./TicketCard/TicketCard";

type Props = {
  id: string;
};

export function TicketProfileCard(props: Props) {
  const { id } = props;

  const { data, loading, error } = useGetTodoQuery({
    variables: { id },
    fetchPolicy: "cache-first"
  });

  if (loading) {
    return <Spinner />;
  }

  if (error) {
    throw error;
  }

  return <TicketCard ticket={data.todo} />;
}
